import { ExpressionRule } from "../../ExpressionRule";
import { ExpressionValue } from "../../ExpressionValue";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class DivideExpression extends ExpressionRule {
    readonly __type: string = "Divide";
    divideValue: ExpressionValue;
    divideBy: ExpressionValue;

    constructor() {
        super();
        this.divideValue = ExpressionValue.createExpressionValue(this, "divideValue");
        this.divideBy = ExpressionValue.createExpressionValue(this, "divideBy");
        this.expressionValueType = new NumberDataDefinition();
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        let divideValue = this.divideValue.evaluate(data, testContext);
        let divideBy = this.divideBy.evaluate(data, testContext);

        if (divideBy === 0) {
            throw new Error("Can not divide by zero");
        }

        return divideValue / divideBy;
    }
}
